module.exports = __webpack_public_path__ + "img/nepalgunj.748d178f.jpg";